import { css } from 'styled-components';
// eslint-disable-next-line import/no-cycle
import { StyledPlaceHolderItem, StyledRow2 } from './PlaceHolder.styles';
import { device } from '../breakpoints';
import { CarouselArticle } from '../ContentItemCarousel/ContentItemCarousel.styles';
import { playGrey10 } from '../design-tokens';

export const getShowcaseLayout = () => css`
    @media ${device.LteSmall} {
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
    }

    @media ${device.GteSmall} {
        flex-direction: row;
    }

    ${StyledPlaceHolderItem} {
        @media ${device.LteSmall} {
            min-width: 100%;

            :nth-child(n + 3) {
                display: none;
            }

            @media ${device.GteSmall} {
                :nth-child(n + 3) {
                    display: inline-block;
                }

                :nth-child(n + 7) {
                    display: none;
                }

                min-width: calc(50% - 2px);
            }
        }

        @media ${device.GteMedium} {
            background: ${playGrey10};
            ${CarouselArticle}
        }

        @media ${device.GteMedium} {
            ${StyledRow2} {
                padding-bottom: 40%;
            }
        }

        @media ${device.GteXLarge} {
            ${StyledRow2} {
                padding-bottom: 30%;
            }
        }

        @media ${device.FullScreen} {
            ${StyledRow2} {
                padding-bottom: 20%;
            }
        }
    }
`;
